<template>
  <b-progress
    :value="value"
    :max="100"
    show-progress
    animated>
  </b-progress>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';

export default {
  mixins: [ BaseColumnRendererMixin ]
};
</script>
